import { render, staticRenderFns } from "./b6.vue?vue&type=template&id=de60f8a8&scoped=true&"
import script from "./b6.vue?vue&type=script&lang=js&"
export * from "./b6.vue?vue&type=script&lang=js&"
import style0 from "./b6.vue?vue&type=style&index=0&id=de60f8a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de60f8a8",
  null
  
)

export default component.exports